import { API } from "aws-amplify";


// handle upload custom font to s3 via backend 
export const  uploadCustomFont=async(requestbody)=>{

    try {
        const response = await API.post('custom-fonts', '/custom-fonts', {
            body: requestbody,
        });
        return response;
    } catch (error) {
        console.error("Error uploading Custom font:", error);
        return null;
    }
};

//  handle get Custom Fonts
export const getCustomFonts=async(customFontKeys=[])=>{
    try{
        const response =  await API.get('custom-fonts', '/custom-fonts', {
            response: true,
            queryStringParameters: {
                Keys:customFontKeys.join(','),
            }
            });
        console.log("response from custom fonts ",JSON.stringify(response.data));
            return response.data;
    }catch(error){
        console.error("Error getting custom fonts", error);
        return null;
    }
};